export type ProjectCostCaps = {
  roofCostCap?: number
  storageCostCap?: number
  batteryCostCap?: number
  hvacCostCap?: number
}

export type TenantCostCapSource = {
  roofCostCap?: number
  storageCostCap?: number
  batteryCostCap?: number
  hvacCostCap?: number
}

/** Copy tenant pricing caps for persisting on a new loan application at creation time. */
export function getProjectCostCaps(tenant: unknown): ProjectCostCaps {
  const t = tenant as TenantCostCapSource
  return {
    roofCostCap: t.roofCostCap,
    storageCostCap: t.storageCostCap,
    batteryCostCap: t.batteryCostCap,
    hvacCostCap: t.hvacCostCap,
  }
}

const hasAnyCap = (caps: ProjectCostCaps | null | undefined): boolean => {
  return caps && (typeof caps.roofCostCap === 'number' ||
    typeof caps.storageCostCap === 'number' ||
    typeof caps.batteryCostCap === 'number' ||
    typeof caps.hvacCostCap === 'number')
}

export function getCostCapsForValidation(
  projectCostCaps: ProjectCostCaps | null | undefined,
  tenantCaps: TenantCostCapSource,
  fallback: 'tenant' | 'none' = 'tenant',
): TenantCostCapSource {
  if (hasAnyCap(projectCostCaps)) {
    return projectCostCaps
  }
  return fallback === 'none' ? {} : tenantCaps
}
